import { ShippingOptionType } from '../../../core/model';
import { Tracking } from './tracking.model';

export enum TraceCrumbCode {
  GA4_ECOM_ITEM_LIST_ATTRIBUTION = 'ga4ecom.itemListAttribution',
}

export interface Ga4TrackingItem extends Tracking {
  item_id: string;
  item_name?: string;
  affiliation?: string;
  coupon?: string;
  discount: number;
  index?: number;
  item_brand?: string;
  item_category: string;
  item_category2?: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  item_list_id?: string;
  item_list_name?: string;
  item_variant?: string;
  location_id?: string;
  price: number;
  quantity: number;
  type?: 'PRODUCT' | 'ARTICLE';
  ticket?: string;
}

export interface Ga4TrackingAddPaymentInfo extends Tracking {
  coupon?: string;
  payment_type: string;
  items: Ga4TrackingItem[];
}

export interface Ga4TrackingAddShippingInfo extends Tracking {
  coupon?: string;
  shipping_tier: string;
  items?: Ga4TrackingItem[];
}

export interface Ga4TrackingAddToCart extends Tracking {
  items: Ga4TrackingItem[];
}

export interface Ga4TrackingAddToWishlist extends Tracking {
  items: Ga4TrackingItem[];
}

export interface Ga4TrackingRemoveFromWishlist extends Tracking {
  items: Ga4TrackingItem[];
}

export interface Ga4TrackingBeginCheckout extends Tracking {
  coupon?: string;
  items: Ga4TrackingItem[];
}

export interface Ga4TrackingGenerateLead extends Tracking {}

export interface Ga4TrackingLogin extends Tracking {
  method: string;
}

export interface Ga4TrackingPurchase extends Tracking {
  transaction_id: string;
  coupon?: string;
  shipping: ShippingOptionType;
  tax: number;
  items: Ga4TrackingItem[];
}

export interface Ga4TrackingRefund extends Tracking {
  transaction_id: string;
  coupon?: string;
  shipping: number;
  tax: number;
  items: Ga4TrackingItem[];
}

export interface Ga4TrackingRemoveFromCart extends Tracking {
  items: Ga4TrackingItem[];
}

export interface Ga4TrackingSelectContent extends Tracking {
  content_type: string;
  content_id: string;
}

export interface Ga4TrackingSelectItem extends Tracking {
  item_list_id: string;
  item_list_name: string;
  items: Ga4TrackingItem[];
}

export interface Ga4TrackingSelectPromotion extends Tracking {
  creative_name: string;
  creative_slot: string;
  promotion_id: string;
  promotion_name: string;
  items: Ga4TrackingItem[];
}

export interface Ga4TrackingShare extends Tracking {
  method: string;
  content_type: string;
  item_id: string;
}

export interface Ga4TrackingSignUp extends Tracking {
  method: string;
}

export interface Ga4TrackingViewCart extends Tracking {
  items: Ga4TrackingItem[];
}

export interface Ga4TrackingViewItem extends Tracking {
  items: Ga4TrackingItem[];
}

export interface Ga4TrackingViewItemList extends Tracking {
  item_list_id: string;
  item_list_name: string;
  items: Ga4TrackingItem[];
}

export interface Ga4TrackingViewPromotion extends Tracking {
  creative_name: string;
  creative_slot: string;
  promotion_id: string;
  promotion_name: string;
  items: Ga4TrackingItem[];
}

export interface Ga4TrackingTutorialBegin extends Tracking {}

export interface Ga4TrackingTutorialComplete extends Tracking {}
